import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedAgeGroupModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add level"
    okText="ADD LEVEL"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a level"
      queryVariables={{ typeId: FILTER_TYPE.AGE_GROUP.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'level is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedAgeGroupModal.Item = Item;

export default RelatedAgeGroupModal;
